module.exports = __webpack_public_path__ + "static/media/carouselone.737787b3.svg";